import { PropsWithChildren, ReactNode, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import appHistory from '../../../app/appHistory';
import { Slider } from '../../../components/Slider/Slider';
import { useDispatch, useSelector } from 'react-redux';
import { getIsLocationPlatformMobileSelector } from '../../Location/locationSelectors';
import BackButton from '../../../components/BackButton/BackButton';
import { UserStatusWidgetWrapperContentDesktopStyled } from './styled/UserStatusWidgetWrapperStyled';
import { LOCATION_NAMES } from '../../Location/locationConstants';
import { locationSlice } from '../../Location/locationReducer';

type IUserStatusWidgetWrapperProps = PropsWithChildren<{
    toggleComponent: ReactNode,
    widgetName: string,
}>;

const locationNames = {
    respawn: LOCATION_NAMES.RESPAWN_STATUS,
    cashback: LOCATION_NAMES.CASHBACK,
};

function UserStatusWidgetWrapper(props: IUserStatusWidgetWrapperProps) {
    const { children, toggleComponent, widgetName } = props;
    const location = useLocation();
    const dispatch = useDispatch();

    const isWidgetContentOpened = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('widget') === widgetName;
    }, [location, widgetName]);

    const isPlatformMobile = useSelector(getIsLocationPlatformMobileSelector);

    const onWrapperClickHandler = useCallback(() => {
        dispatch(locationSlice.actions.openLocationAction({
            name: locationNames[widgetName],
        }));
    }, [widgetName, dispatch]);

    const onContentCloseHandler = useCallback(() => {
        appHistory.goBack();
    }, []);

    return isPlatformMobile
        ? <>
            <div onClick={onWrapperClickHandler}>
                {toggleComponent}
            </div>
            <Slider
                show={isWidgetContentOpened}
                placement={'bottom'}
                showCloseButton={false}
                swipeDownToClose
                onClose={onContentCloseHandler}
            >
                {children}
            </Slider>
        </>
        : isWidgetContentOpened
            ? <UserStatusWidgetWrapperContentDesktopStyled>
                <BackButton/>
                {children}
            </UserStatusWidgetWrapperContentDesktopStyled>
            : <div onClick={onWrapperClickHandler}>
                {toggleComponent}
            </div>;
}

export default UserStatusWidgetWrapper;
